import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const atera = defineConnector({
  identifier: "atera",
  name: "Atera",
  tagLine: "All-in-one IT management for MSPs",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://app\\.atera\\.com/api/.*",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Atera](https://www.atera.com/), go to **Admin → API** and generate a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Atera API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.atera.com/api/v3/agents",
  },
});
